<template>
  <div class="full-height">
    <div
      v-if="homeType=='1'"
      class="home2 full-height home-banner"
    >
      <div style="padding-top:40px;">
        <ld-header
          transparent
          @click-left="function(){}"
          @click-right="$router.push({ path: '/service' })"
        >
          <template #left>
            <span class="logo font18 white">
              {{ loginConfig.pageName }}
            </span>
          </template>
          <template #right>
            <!-- <div
              v-if="loginConfig.by4=='QHHK'"
              class="inline-block white server"
              @click="changeHome"
              style="padding-right:4px;"
            >
              <span style="display:inline-block;padding:0px 2px;border:1px solid #fff;border-radius:3px;">
                <van-icon
                  name="exchange"
                  class="font18"
                  style="color:#fff"
                />
              </span>
              <p class="font12">
                版本
              </p>
            </div> -->
            <div class="server">
              <van-icon name="service" />
              <p class="font12">
                {{ $t('A022','专属客服') }}
              </p>
            </div>
          </template>
        </ld-header>
      </div>
      <div class="home-notice">
        <van-notice-bar
          v-if="loginNotices && loginNotices.length"
          class=" full-width round-sm"
          left-icon="volume-o"
          style="height: 28px;"
          mode="closeable"
        >
          <span
            v-for="notice in loginNotices"
            :key="notice.id"
            @click="$router.push({ path: `/userCenter/noticeDetail/${notice.id}` })"
          >
            {{ notice.content }}
          </span>
        </van-notice-bar>
      </div>
      <div class="welcome font18 white">
        {{ $t('A029','欢迎您') }}，{{ userInfo&&userInfo.empInfo && userInfo.empInfo.empName }}
        <div
          class="white font24 font-lg"
          v-ldsk="userInfo&&userInfo.vipCorp?userInfo.vipCorp.corpNo:''"
        >
          {{ userInfo&&userInfo.vipCorp && userInfo.vipCorp.fullname }}
        </div>
      </div>
      <div class="menu bg-white">
        <van-grid
          :column-num="5"
          :border="false"
          icon-size="44"
        >
          <van-grid-item
            v-for="tab in menuList"
            :key="tab.link"
            :icon="tab.img"
            :text="$t(tab.title)"
            :class="[tab.openDiasble ? 'menu-disabled' : '']"
            @click="to(tab)"
          />
        </van-grid>

        <van-grid
          :column-num="5"
          :border="false"
          style="flex-wrap: nowrap;"
        >
          <van-grid-item
            v-for="(item,index) in menuList_other"
            :key="index"
            :to="item.link"
            :url="item.url"
            :class="[item.openDiasble ? 'menu-disabled' : '']"
            @click="to(item)"
          >
            <template #icon>
              <ld-icon
                :color="item.color"
                size="30"
                :type="item.icon"
              />
              <van-icon
                :name="item.img"
                size="28"
              />
            </template>
            <template #text>
              <span
                class="van-grid-item__text"
                :style="{ color: item.disabled && '#ccc' }"
              >{{ item.title }}</span>
            </template>
          </van-grid-item>
        </van-grid>
      </div>
    </div>
    <div v-else>
      <home
        :menulist="menulist"
        @changeHome="changeHome"
      />
    </div>
  </div>
</template>

<script>
import { Tabbar, TabbarItem ,Popup, Grid, GridItem, Icon, NoticeBar } from 'vant'
import home from 'Components/Dynamic/default/home.vue'
// import ldButton from 'Common/ldButton'
import { localget , localset} from 'Utils/storage.js'

import menu_tk from 'Assets/images/home/menu_tk.png'
import menu_ht from 'Assets/images/home/menu_ht.png'
import menu_tr from 'Assets/images/home/menu_tr.png'
import menu_car from 'Assets/images/home/menu_car.png'

import menu_tk1 from 'Components/Dynamic/qhhk/images/menu/tk.png'
import menu_ht1 from 'Components/Dynamic/qhhk/images/menu/ht.png'
import menu_tr1 from 'Components/Dynamic/qhhk/images/menu/tr.png'
import menu_car1 from 'Components/Dynamic/qhhk/images/menu/car.png'

import menu_visa from 'Assets/images/home/menu_visa.png'
import menu_strategy from 'Assets/images/home/menu_strategy.png'
import menu_discount from 'Assets/images/home/menu_discount.png'
import menu_freebus from 'Assets/images/home/menu_freebus.png'
import menu_contracthotel from 'Assets/images/home/menu_contracthotel.png'
import menu_policy from 'Assets/images/home/menu_policy.png'

// import menu_bxsc from 'Assets/images/home/menu_bxsc.png'
import ldHeader from 'Common/ldHeader'
import homeMixin from '../default/homeMixin'

export default {
  name: 'Home',
  mixins: [homeMixin],
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Popup.name]: Popup,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Icon.name]: Icon,
    [NoticeBar.name]: NoticeBar,
    ldHeader,
    home,
    // ldButton
  },
  data () {
    return {
      homeType:'1',
      menulist: [
        {
          link: '/tk/tkQuery',
          title: 'A008', //机票
          img: menu_tk1,
          label: '低价机票，舒适出行',
          PRO_TYPE: 10901,
        },
        {
          link: '/ht/htQuery',
          title: 'A009', //酒店
          img: menu_ht1,
          label: '尊贵入住，商旅独享',
          PRO_TYPE: 10903,
        },
        {
          link: '/tr/trQuery',
          title: 'A010', //火车票
          img: menu_tr1,
          label: '舒适高铁，在线选座',
          PRO_TYPE: 10904,
        },
        {
          link: '/car/carQuery',
          title: 'A011', //用车
          img: menu_car1,
          label: '晚点必等，安心出行',
          PRO_TYPE: 10906,
        }
      ],
      menuList:[
        {
          link: '/tk/tkQuery',
          title: 'A008',//机票
          img: menu_tk,
          PRO_TYPE: 10901,
        },
        {
          link: '/ht/htQuery',
          title: 'A009',//酒店
          img: menu_ht,
          PRO_TYPE: 10903,
        },
        {
          link: '/tr/trQuery',
          title: 'A010',//火车票
          img: menu_tr,
          PRO_TYPE: 10904,
        },
        {
          link: '/car/carQuery',
          title: 'A011',//用车
          img: menu_car,
          PRO_TYPE: 10906,
        },
        {
          link: '/visa',
          title: 'A012',//签证
          img: menu_visa,
          PRO_TYPE: 10913,
        }
      ],
      menuList_minor: [
        // {
        // 	url: 'https://tongchengbx.ly.com/baoxian/tongchengbx/#/activity/reportlist?id=4',
        // 	title: '保险商城',//'',
        // 	img: menu_bxsc
        // },
        {
          link: '/tkIntel/policy',
          title: 'A019',//'国际特惠',
          img: menu_strategy
        },
        {
          link: '/tk/policy',
          title: 'A020',//'协议直减',
          img: menu_discount
        },
        {
          link: '/tk/airportBus',
          title: 'Q016',//机场大巴
          img: menu_freebus
        },
        {
          link: '/ht/htQuery/htSignList',
          title: 'A021',//'协议酒店',
          img: menu_contracthotel
        },
        {
          link: '/tk/strategy',
          title: 'Q007',//机场攻略
          img: menu_policy,
          openDiasble: true
        },
      ],
      menuList_other: [
        // {
        // 	url: 'https://tongchengbx.ly.com/baoxian/tongchengbx/#/activity/reportlist?id=4',
        // 	title: '保险商城',//'',
        // 	img: menu_bxsc
        // },
        {
          link: '/checkIn',
          title: '优先值机',
          icon: 'iconweibiaoti-2',
          color:'#48bfea',
        },
        {
          link: '/guestPass',
          title: '要客通',
          icon: 'iconweibiaoti-21',
          color:'#4887df',
        },
        {
          link: '/fastCheck',
          title: '快速安检',
          icon: 'iconweibiaoti-22',
          color:'#8bc249',
        },
        {
          link: '/restRoom',
          title: '休息室',
          icon: 'iconweibiaoti-23',
          color:'#f7bc33',
        },
        // {
        // 	link: '/home',
        // 	title: '敬请期待',
        // 	icon: 'iconweibiaoti-24',
        // 	color:'#248aff',
        // 	disabled: true
        // }
      ],
    }
  },
  async created() {
    var homeType=localget('homeType')
    if(homeType==1||homeType==2){
      this.homeType=homeType
    }else {
      this.homeType=1
    }
    localset('homeType',this.homeType)
    await this.getAuthorizationPnos()
    this.genMenu([...this.menuList, ...this.menuList_other])
    this.getLoginNotice(0) //获取登录公告
    this.getBadgeCount()
    this.checkOpenId()
  },
  methods:{
  }
}
</script>

<style lang="less" scoped>
@font-face {
  font-family: 'paopao';
  src:url('~Assets/font/paopao/paopao.ttf') format('truetype');
}
.home2 {
    // position: relative;
    padding: 10px;
	background-size: cover;
	.logo {
        font-family: 'paopao';
	}

    .welcome {
        padding: 5px 10px;
    }

    .home-notice {
        padding: 5px 10px;
    }

    .server {
        color: @color-text-white !important;
        font-size: 24px;
        > p {
            margin-top: -3px;
        }
        .van-icon{
            color: @color-text-white !important;
        }
    }

    .menu {
        position: absolute;
        bottom: 60px;
        width: 7.1rem;
        padding: 8px;
        border-radius: @border-radius-md;
        .more {
        margin-top: 15px;
        line-height: 36px;
        }
    }

}



</style>
